<template>
  <el-container :class="pageClass">
    <el-header><top-bar :is-single="true" /></el-header>
    <div class="single-main">
      <router-view />
      <div
        v-if="$store.state.page.loading && !$store.state.page.isProcessLoading"
        :id="utils.getIds('common', 'pls_wait_icon')"
        class="el-loading-mask"
      >
        <div id="wait_img" class="dni-page-loading">
          <div id="wait_text">{{ $t("wizard_pls_wait") }}</div>
          <img src="~images/wizard/wait.gif" />
        </div>
      </div>
      <div
        v-if="$store.state.page.loading && $store.state.page.isProcessLoading"
        class="el-loading-process"
        :class="$store.state.page.loadingClass"
      >
        <div id="prgbar1">
          <div id="process" :style="{ width: $store.state.page.process + '%' }"></div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import TopBar from "@/components/header/topBar";
export default {
  components: { TopBar },
  async beforeCreate() {
    if (!this.$route.path.includes("logout")) {
      await this.$store.dispatch("user/loadLocaleLanguage");
    }
  },
  computed: {
    pageClass() {
      let classNames = [];
      if (this.$store.state.page.type) {
        classNames.push(this.$store.state.page.type);
      }
      if (this.$store.state.page.style) {
        classNames.push(this.$store.state.page.style);
      }
      return classNames.join(" ");
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.el-container {
  min-width: $pageMiniWidth - 10px;
}
.single-main {
  position: absolute;
  top: $level1Height;
  left: 0;
  right: 0;
  bottom: 0;
  min-width: $pageMiniWidth;
  background: #fff;
}
.orbi.gui-2-1 {
  .single-main {
    border-top: 1px solid #ccc;
  }
}
</style>
